import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShiftEmployee } from 'src/app/models/shift.model';

@Component({
    selector: 'app-shift-drawer',
    templateUrl: './shift-drawer.component.html',
    styleUrls: ['./shift-drawer.component.css'],
    standalone: false
})
export class ShiftDrawerComponent {
  @Input() isOpen = false;
  @Input() editingShift: any = null;
  @Input() isEditMode = false;
  @Input() employees: ShiftEmployee[] = [];
  @Output() closed = new EventEmitter<void>();
  @Output() shiftCreated = new EventEmitter<any>();
  @Output() shiftUpdated = new EventEmitter<any>();

  onFormSubmit(formData: any): void {
    console.log('Drawer received form data:', { isEditMode: this.isEditMode, formData }); // Debug log
    
    if (this.isEditMode) {
      this.shiftUpdated.emit(formData);
    } else {
      this.shiftCreated.emit(formData);
    }
  }

  close(): void {
    this.isOpen = false;
    this.closed.emit();
  }
}
